export const ConsentTab = {
  GIVEN_CONSENTS: 'given',
};
